<script setup>
import AppLayout from '@/Layouts/AppLayout.vue'
import HeroSection from '@/Components/Landing/HeroSection.vue'
import HowItWorksSection from '@/Components/Landing/HowItWorksSection.vue'
import UspSection from '@/Components/Landing/UspSection.vue'
import AffordabilitySection from '@/Components/Landing/AffordabilitySection.vue'
import WhoForSection from '@/Components/Landing/WhoForSection.vue'
import RecordedContentSection from '@/Components/Landing/RecordedContentSection.vue'
import TestimonialsSection from '@/Components/Landing/TestimonialsSection.vue'
import SubjectsSection from '@/Components/Landing/SubjectsSection.vue'
import FinalCtaSection from '@/Components/Landing/FinalCtaSection.vue'

defineProps({
  subjects: {
    type: Array,
    default: () => []
  }
})
</script>

<template>
  <AppLayout>
    <main>
      <HeroSection />
      <HowItWorksSection />
      <UspSection />
      <AffordabilitySection />
      <WhoForSection />
      <RecordedContentSection />
      <!-- <TestimonialsSection /> -->
      <SubjectsSection :subjects="subjects" />
      <FinalCtaSection />
    </main>
  </AppLayout>
</template>
